<template lang="pug">
    div.Goal(v-if="currentStep.data")
        lessonHeader
        stepTitle
        div.Goal-text {{currentStep.text}}
        v-spacer.py-2
        div.Goal-card
            div.Goal-text
                | Ingresa el nombre de tu meta, su costo y selecciona la fecha de corte de tu tarjeta de crédito
            v-spacer.py-2
            v-layout(row wrap)
                v-spacer.py-2
                v-flex(xs6)
                    v-spacer.py-2
                    div.Goal-label Mi meta:
                    v-text-field.Goal-text-field(@input="changeGoal" placeholder="Introduzca un texto" v-model="currentStep.data.goalText")
                    div.Goal-label Costo:
                    v-text-field.Goal-text-field(@input="changeGoal" placeholder=" 0.00" prefix="$" v-model="currentStep.data.goalValue")
                    div.Goal-label Estrategia:
                    v-text-field.Goal-text-field(@input="changeGoal" placeholder="Introduzca un texto" v-model="currentStep.data.goalStrategy")
                    div.Goal-avatar
                        v-avatar(:size="25" color="#6b4946")
                        span.Goal-span Hoy
                    div.Goal-avatar
                        v-avatar(:size="25" color="#59BFFD")
                        span.Goal-span Tu día de corte
                v-flex(xs6)
                    div.Goal-calendar-container
                        calendar.Goal-calendar(@dateSelected="changeGoal" ref="calendar")
                    div Recuerda que siempre puedes volver a tu presupuesto para organizar tus finanzas y de esta forma, contar con los fondos suficientes para cumplir tu meta.
                    v-spacer.py-2
                    el-button.Goal-button(type="success" @click="dialog = true") Ver presupuesto
        v-spacer.py-2
        el-button.Goal-button(type="primary" :disabled="reportButtonDisabled" @click="report") Generar reporte
        lessonFooter
        v-dialog(v-model="dialog" width="700")                
            v-card
                v-layout(row wrap)                    
                    v-flex.card.flex(xs12)
                        div.title-e Tu presupuesto mensual
                        v-layout(row wrap)
                            v-flex(xs6)
                                div.Budget_sub TOTAL DE INGRESOS
                                div.Budget_sub-total {{income | toCurrency}}
                            v-flex(xs6)
                                div.Budget_sub TOTAL DE GASTOS
                                div.Budget_sub-total {{expenses| toCurrency}}
                        div.Budget_card
                            v-layout(row wrap)
                                v-flex(xs6)
                                    div.Budget_label DÉFICIT
                                    div.Budget_card-value1 {{deficit | toCurrency}}
                                v-flex(xs6)
                                    div.Budget_label EXCEDENTE
                                    div.Budget_card-value1 {{surplus | toCurrency}}
                            div
                                div.Budget_label TOTAL DE PAGOS CON TARJETA
                                div.Budget_card-value2 {{cardpays | toCurrency}}
                v-spacer.py-2
                v-divider                
                v-card-actions
                    v-spacer
                    v-btn(color="primary" flat @click="dialog = false") Cerrar
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import lessonHeader from "@/components/lesson-header/lesson-header";
import stepTitle from '@/components/step-title/step-title'
import lessonFooter from "@/components/lesson-footer/lesson-footer";
import calendar from "@/components/calendar/calendar";
import {currencyFormat} from "@/utils/utils";

export default {
  name: 'Goal',
  components:{
	lessonHeader,    
	stepTitle,           
    lessonFooter,
    calendar
  }, 
  computed: {
      ...mapGetters(['currentStep', 'currentGroup']),
    income() {        
        const step = this.currentGroup.steps.find(s => s.componentPath === 'components/lessons/TDC/L2/2-1-presupuesto');
        return step.data.budget;
    },
    expenses() {
        const step = this.currentGroup.steps.find(s => s.componentPath === 'components/expenses/expenses');
        return step.data.expensesTotal;        
    },
    deficit() {
        const budget = this.currentGroup.steps.find(s => s.componentPath === 'components/lessons/TDC/L2/2-1-presupuesto');
        const expenses = this.currentGroup.steps.find(s => s.componentPath === 'components/expenses/expenses');
        return (budget.data.budget < expenses.data.expensesTotal)?
            budget.data.budget - expenses.data.expensesTotal: 0;
    },
    surplus() {
        const budget = this.currentGroup.steps.find(s => s.componentPath === 'components/lessons/TDC/L2/2-1-presupuesto');
        const expenses = this.currentGroup.steps.find(s => s.componentPath === 'components/expenses/expenses');
        if(budget.data.budget > expenses.data.expensesTotal) {
            this.currentStep.points = 1;
        }
        return (budget.data.budget > expenses.data.expensesTotal)?
            budget.data.budget - expenses.data.expensesTotal: 0; 
    },
    cardpays() {
        const expenses = this.currentGroup.steps.find(s => s.componentPath === 'components/expenses/expenses')
        let result = 0;        
        expenses.data.items.forEach(i => {
            i.fixeds.forEach(f => {
                if (f.value) {
                    const value = Number(f.value.replace(/\,/g, ''));
                    if (value && f.paybycard) {
                        result += value;
                    }
                }
            });
            i.variables.forEach(v => {
                if (v.value) {
                    const value = Number(v.value.replace(/\,/g, ''));
                    if (value && v.paybycard) {
                        result += value;
                    }
                }
            });
        });        
        return result;
    }
  },
  mounted() {
      this.currentStep.data.goalStrategy = 'Financiamiento de 50 días';
  },
  watch: {
    currentStep: {
      handler(val) {          
        if(val.componentPath === "components/goal/goal") {
            if(this.currentStep.data.goalDay) {                
                this.$nextTick(()=> {                   
                    this.setGoalDay()
                });                
            }
        }        
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['nextStepSCORM']),
    setGoalDay() {
        debugger
        this.$refs.calendar.selectDate(this.currentStep.data.goalDay._date);
    },
    changeGoal(day) {        
        const hashText = this.currentStep.data.goalText && this.currentStep.data.goalText.length > 0;
        const hashValue = this.currentStep.data.goalValue;
        const hashStrategy = this.currentStep.data.goalStrategy && this.currentStep.data.goalStrategy.length > 0;
        let hashDay = this.currentStep.data.goalDay;
        if (event.type === "click") {
            hashDay = day;
            this.currentStep.data.goalDay = day;
        }
        if (hashText && hashValue && hashStrategy && hashDay) {
            this.reportButtonDisabled = false;
        }
        this.format();
    },
    report() {
        this.nextStepSCORM();
    },
    format (expense) {
        this.currentStep.data.goalValue = currencyFormat(this.currentStep.data.goalValue);
	}
  },
  data() {
      return {
          reportButtonDisabled: true,
          dialog: false
      }
  }
}
</script>

<style scoped>
    @import 'goal.scss';
</style>

